// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/PermanentMarker-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Gaegu-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Assets/sherlock-shadow.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Assets/sherlock-221b-wallpaper2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Permanent Marker";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Gaegu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

:root {
  color-scheme: dark;
  --bg: #0a0907;
  --panel: rgba(8, 8, 8, 0.84);
  --panel-strong: rgba(0, 0, 0, 0.92);
  --text: #f6efe6;
  --muted: #c9bca9;
  --accent: #c7a14a;
  --accent-strong: #e1ba60;
  --danger: #d54e42;
  --success: #4eae62;
  --line: rgba(255, 250, 232, 0.18);
  --shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
  background: radial-gradient(circle at top, rgba(189, 154, 83, 0.16), transparent 32%), var(--bg);
  color: var(--text);
  font-family: "Open Sans", sans-serif;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input,
select {
  font: inherit;
}

.page-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.page-shell.home {
  background-image: linear-gradient(rgba(10, 9, 7, 0.58), rgba(10, 9, 7, 0.82)), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.page-shell.board {
  background-image: linear-gradient(rgba(10, 9, 7, 0.52), rgba(10, 9, 7, 0.88)), url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.2));
}

.topbar-logo {
  width: min(260px, 55vw);
  height: auto;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.page-content {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: min(1100px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 1.5rem 0 3rem;
}

.hero-center {
  flex: 1 0 auto;
  display: grid;
  place-items: end center;
  padding-bottom: 4rem;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.panel {
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 24px;
  box-shadow: var(--shadow);
  backdrop-filter: blur(10px);
}

.panel.strong {
  background: var(--panel-strong);
}

.headline,
.section-title,
.card-name,
.accent-font {
  font-family: "Permanent Marker", cursive;
  letter-spacing: 0.04em;
}

.headline {
  font-size: clamp(2rem, 4vw, 3.4rem);
  margin: 0;
}

.subtle {
  color: var(--muted);
}

.button-row {
  display: flex;
  gap: 0.9rem;
  flex-wrap: wrap;
}

.button,
.icon-button,
.ghost-button {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  cursor: pointer;
  transition: transform 140ms ease, border-color 140ms ease, background 140ms ease;
}

.button:hover,
.icon-button:hover,
.ghost-button:hover {
  transform: translateY(-1px);
}

.button {
  padding: 0.9rem 1.35rem;
  background: linear-gradient(180deg, rgba(199, 161, 74, 0.32), rgba(122, 87, 24, 0.18));
  color: var(--text);
}

.button.primary {
  background: linear-gradient(180deg, rgba(199, 161, 74, 0.9), rgba(129, 84, 22, 0.88));
  color: #17120a;
  border-color: rgba(255, 224, 147, 0.44);
}

.button.success {
  background: linear-gradient(180deg, rgba(82, 174, 98, 0.95), rgba(41, 112, 53, 0.88));
}

.button.danger {
  background: linear-gradient(180deg, rgba(213, 78, 66, 0.95), rgba(131, 32, 32, 0.86));
}

.button:disabled,
.icon-button:disabled,
.ghost-button:disabled {
  opacity: 0.42;
  cursor: not-allowed;
  transform: none;
}

.ghost-button {
  padding: 0.8rem 1.15rem;
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
}

.icon-button {
  width: 44px;
  height: 44px;
  display: inline-grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
}

.grid {
  display: grid;
  gap: 1.2rem;
}

.grid.two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.setup-card,
.game-card,
.info-card {
  padding: 1.4rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.field input,
.field select {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 16px;
  padding: 0.85rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  color: var(--text);
}

.slider-row {
  display: grid;
  gap: 0.75rem;
}

.step-indicator {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.step-pill {
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--muted);
}

.step-pill.active {
  background: rgba(199, 161, 74, 0.25);
  color: var(--text);
}

.card-list {
  display: grid;
  gap: 0.9rem;
}

.card-tile,
.status-card,
.detective-card {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 1rem;
  padding: 1rem;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.card-tile.selected {
  border-color: rgba(82, 174, 98, 0.62);
  background: rgba(82, 174, 98, 0.16);
}

.card-tile.resolved-envelope {
  border-color: rgba(82, 174, 98, 0.72);
  background: linear-gradient(180deg, rgba(82, 174, 98, 0.2), rgba(82, 174, 98, 0.08));
  box-shadow: inset 0 0 0 1px rgba(82, 174, 98, 0.18);
}

.card-tile.clickable,
.status-card.clickable {
  cursor: pointer;
}

.status-card.selected {
  border-color: rgba(82, 174, 98, 0.62);
  background: rgba(82, 174, 98, 0.16);
}

.card-thumb {
  width: 88px;
  height: 88px;
  border-radius: 18px;
  object-fit: cover;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.38);
}

.card-meta {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
}

.card-name {
  font-size: 1.15rem;
}

.meta-line {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.meta-line strong {
  color: var(--accent-strong);
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--muted);
}

.banner {
  padding: 1rem 1.2rem;
  border-radius: 20px;
  background: rgba(199, 161, 74, 0.14);
  border: 1px solid rgba(225, 186, 96, 0.2);
}

.tabs {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.tab {
  padding: 0.7rem 1rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: var(--muted);
  cursor: pointer;
}

.tab.active {
  background: rgba(199, 161, 74, 0.24);
  color: var(--text);
}

.fab {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(180deg, rgba(221, 112, 88, 0.96), rgba(160, 39, 29, 0.92));
  box-shadow: 0 24px 60px rgba(105, 20, 15, 0.48);
  cursor: pointer;
}

.fab img {
  width: 46px;
  height: 46px;
}

.detective-hand {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
  gap: 0.75rem;
}

.detective-card {
  grid-template-columns: 1fr;
}

.exposure-grid {
  display: grid;
  gap: 0.9rem;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.exposure-grid.compact {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.exposure-card {
  grid-template-columns: 1fr;
}

.user-hand-grid {
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.user-exposure-card {
  align-items: center;
}

.exposure-line {
  align-items: flex-start;
}

.tag-success {
  background: rgba(82, 174, 98, 0.22);
  color: var(--text);
}

.tag-accent {
  background: rgba(199, 161, 74, 0.22);
  color: var(--text);
}

.thumb-only {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  align-items: center;
  text-align: center;
}

.thumb-only img {
  width: 78px;
  height: 78px;
  border-radius: 18px;
  object-fit: cover;
}

.solution-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.error-copy {
  font-family: "Gaegu", cursive;
  font-size: 1.5rem;
}


.audit-list {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.audit-entry {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 1.1rem;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.audit-entry.current {
  border-color: rgba(82, 174, 98, 0.5);
  background: rgba(82, 174, 98, 0.12);
}

.audit-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.audit-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.audit-summary {
  color: var(--text);
  font-weight: 600;
}

.audit-change-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.audit-change-line {
  margin: 0;
}

.audit-current-tag {
  color: var(--text);
  background: rgba(82, 174, 98, 0.26);
}

.audit-restore-button {
  white-space: nowrap;
}

.empty-state {
  margin: 0;
}

.overlay-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(12px);
}

.overlay-panel {
  width: min(820px, 100%);
  max-height: calc(100vh - 2rem);
  margin: 0;
  overflow: auto;
}

.dialog-copy {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.page-footer {
  margin-top: auto;
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.25rem 1.5rem;
  color: var(--muted);
  font-size: 0.95rem;
  text-align: center;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.14));
}

.page-footer a {
  color: var(--accent-strong);
}

.page-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .grid.two,
  .solution-grid {
    grid-template-columns: 1fr;
  }

  .topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .topbar-logo {
    width: min(240px, 70vw);
  }
}

@media (max-width: 640px) {
  .page-content {
    width: min(100% - 1rem, 1100px);
  }

  .card-tile,
  .status-card {
    grid-template-columns: 1fr;
  }

  .card-thumb {
    width: 100%;
    max-width: 220px;
    height: auto;
    aspect-ratio: 1 / 1;
    justify-self: center;
  }

  .fab {
    width: 72px;
    height: 72px;
    right: 1rem;
    bottom: 1rem;
  }

  .button-row,
  .topbar-actions,
  .tabs {
    width: 100%;
  }

  .button,
  .ghost-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/web/styles.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+DAAmE;AACrE;;AAEA;EACE,wBAAwB;EACxB,+DAA4D;AAC9D;;AAEA;EACE,oBAAoB;EACpB,+DAAyD;AAC3D;;AAEA;EACE,qBAAqB;EACrB,+DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gGAAgG;EAChG,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sHAAmH;AACrH;;AAEA;EACE,sHAA4H;AAC9H;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;EAIE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,gFAAgF;AAClF;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sFAAsF;EACtF,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;EACrF,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,qFAAqF;AACvF;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,oFAAoF;EACpF,mDAAmD;AACrD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,0CAA0C;EAC1C,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sFAAsF;EACtF,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["@font-face {\n  font-family: \"Permanent Marker\";\n  src: url(\"../fonts/PermanentMarker-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../fonts/OpenSans-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Gaegu\";\n  src: url(\"../fonts/Gaegu-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../fonts/Roboto-Regular.ttf\") format(\"truetype\");\n}\n\n:root {\n  color-scheme: dark;\n  --bg: #0a0907;\n  --panel: rgba(8, 8, 8, 0.84);\n  --panel-strong: rgba(0, 0, 0, 0.92);\n  --text: #f6efe6;\n  --muted: #c9bca9;\n  --accent: #c7a14a;\n  --accent-strong: #e1ba60;\n  --danger: #d54e42;\n  --success: #4eae62;\n  --line: rgba(255, 250, 232, 0.18);\n  --shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  background: radial-gradient(circle at top, rgba(189, 154, 83, 0.16), transparent 32%), var(--bg);\n  color: var(--text);\n  font-family: \"Open Sans\", sans-serif;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton,\ninput,\nselect {\n  font: inherit;\n}\n\n.page-shell {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.page-shell.home {\n  background-image: linear-gradient(rgba(10, 9, 7, 0.58), rgba(10, 9, 7, 0.82)), url(\"../Assets/sherlock-shadow.jpg\");\n}\n\n.page-shell.board {\n  background-image: linear-gradient(rgba(10, 9, 7, 0.52), rgba(10, 9, 7, 0.88)), url(\"../Assets/sherlock-221b-wallpaper2.jpg\");\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.2));\n}\n\n.topbar-logo {\n  width: min(260px, 55vw);\n  height: auto;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.page-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  width: min(1100px, calc(100% - 2rem));\n  margin: 0 auto;\n  padding: 1.5rem 0 3rem;\n}\n\n.hero-center {\n  flex: 1 0 auto;\n  display: grid;\n  place-items: end center;\n  padding-bottom: 4rem;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.panel {\n  background: var(--panel);\n  border: 1px solid var(--line);\n  border-radius: 24px;\n  box-shadow: var(--shadow);\n  backdrop-filter: blur(10px);\n}\n\n.panel.strong {\n  background: var(--panel-strong);\n}\n\n.headline,\n.section-title,\n.card-name,\n.accent-font {\n  font-family: \"Permanent Marker\", cursive;\n  letter-spacing: 0.04em;\n}\n\n.headline {\n  font-size: clamp(2rem, 4vw, 3.4rem);\n  margin: 0;\n}\n\n.subtle {\n  color: var(--muted);\n}\n\n.button-row {\n  display: flex;\n  gap: 0.9rem;\n  flex-wrap: wrap;\n}\n\n.button,\n.icon-button,\n.ghost-button {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n  cursor: pointer;\n  transition: transform 140ms ease, border-color 140ms ease, background 140ms ease;\n}\n\n.button:hover,\n.icon-button:hover,\n.ghost-button:hover {\n  transform: translateY(-1px);\n}\n\n.button {\n  padding: 0.9rem 1.35rem;\n  background: linear-gradient(180deg, rgba(199, 161, 74, 0.32), rgba(122, 87, 24, 0.18));\n  color: var(--text);\n}\n\n.button.primary {\n  background: linear-gradient(180deg, rgba(199, 161, 74, 0.9), rgba(129, 84, 22, 0.88));\n  color: #17120a;\n  border-color: rgba(255, 224, 147, 0.44);\n}\n\n.button.success {\n  background: linear-gradient(180deg, rgba(82, 174, 98, 0.95), rgba(41, 112, 53, 0.88));\n}\n\n.button.danger {\n  background: linear-gradient(180deg, rgba(213, 78, 66, 0.95), rgba(131, 32, 32, 0.86));\n}\n\n.button:disabled,\n.icon-button:disabled,\n.ghost-button:disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.ghost-button {\n  padding: 0.8rem 1.15rem;\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text);\n}\n\n.icon-button {\n  width: 44px;\n  height: 44px;\n  display: inline-grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text);\n}\n\n.grid {\n  display: grid;\n  gap: 1.2rem;\n}\n\n.grid.two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.setup-card,\n.game-card,\n.info-card {\n  padding: 1.4rem;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.field input,\n.field select {\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 16px;\n  padding: 0.85rem 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text);\n}\n\n.slider-row {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.step-indicator {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.step-pill {\n  padding: 0.5rem 0.9rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--muted);\n}\n\n.step-pill.active {\n  background: rgba(199, 161, 74, 0.25);\n  color: var(--text);\n}\n\n.card-list {\n  display: grid;\n  gap: 0.9rem;\n}\n\n.card-tile,\n.status-card,\n.detective-card {\n  display: grid;\n  grid-template-columns: 88px minmax(0, 1fr);\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.card-tile.selected {\n  border-color: rgba(82, 174, 98, 0.62);\n  background: rgba(82, 174, 98, 0.16);\n}\n\n.card-tile.resolved-envelope {\n  border-color: rgba(82, 174, 98, 0.72);\n  background: linear-gradient(180deg, rgba(82, 174, 98, 0.2), rgba(82, 174, 98, 0.08));\n  box-shadow: inset 0 0 0 1px rgba(82, 174, 98, 0.18);\n}\n\n.card-tile.clickable,\n.status-card.clickable {\n  cursor: pointer;\n}\n\n.status-card.selected {\n  border-color: rgba(82, 174, 98, 0.62);\n  background: rgba(82, 174, 98, 0.16);\n}\n\n.card-thumb {\n  width: 88px;\n  height: 88px;\n  border-radius: 18px;\n  object-fit: cover;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.38);\n}\n\n.card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.card-name {\n  font-size: 1.15rem;\n}\n\n.meta-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.meta-line strong {\n  color: var(--accent-strong);\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.25rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--muted);\n}\n\n.banner {\n  padding: 1rem 1.2rem;\n  border-radius: 20px;\n  background: rgba(199, 161, 74, 0.14);\n  border: 1px solid rgba(225, 186, 96, 0.2);\n}\n\n.tabs {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.tab {\n  padding: 0.7rem 1rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--muted);\n  cursor: pointer;\n}\n\n.tab.active {\n  background: rgba(199, 161, 74, 0.24);\n  color: var(--text);\n}\n\n.fab {\n  position: fixed;\n  right: 1.5rem;\n  bottom: 1.5rem;\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(180deg, rgba(221, 112, 88, 0.96), rgba(160, 39, 29, 0.92));\n  box-shadow: 0 24px 60px rgba(105, 20, 15, 0.48);\n  cursor: pointer;\n}\n\n.fab img {\n  width: 46px;\n  height: 46px;\n}\n\n.detective-hand {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));\n  gap: 0.75rem;\n}\n\n.detective-card {\n  grid-template-columns: 1fr;\n}\n\n.exposure-grid {\n  display: grid;\n  gap: 0.9rem;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n}\n\n.exposure-grid.compact {\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n}\n\n.exposure-card {\n  grid-template-columns: 1fr;\n}\n\n.user-hand-grid {\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n}\n\n.user-exposure-card {\n  align-items: center;\n}\n\n.exposure-line {\n  align-items: flex-start;\n}\n\n.tag-success {\n  background: rgba(82, 174, 98, 0.22);\n  color: var(--text);\n}\n\n.tag-accent {\n  background: rgba(199, 161, 74, 0.22);\n  color: var(--text);\n}\n\n.thumb-only {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  align-items: center;\n  text-align: center;\n}\n\n.thumb-only img {\n  width: 78px;\n  height: 78px;\n  border-radius: 18px;\n  object-fit: cover;\n}\n\n.solution-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.error-copy {\n  font-family: \"Gaegu\", cursive;\n  font-size: 1.5rem;\n}\n\n\n.audit-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.audit-entry {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem 1.1rem;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.audit-entry.current {\n  border-color: rgba(82, 174, 98, 0.5);\n  background: rgba(82, 174, 98, 0.12);\n}\n\n.audit-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.audit-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.audit-summary {\n  color: var(--text);\n  font-weight: 600;\n}\n\n.audit-change-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.audit-change-line {\n  margin: 0;\n}\n\n.audit-current-tag {\n  color: var(--text);\n  background: rgba(82, 174, 98, 0.26);\n}\n\n.audit-restore-button {\n  white-space: nowrap;\n}\n\n.empty-state {\n  margin: 0;\n}\n\n.overlay-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(12px);\n}\n\n.overlay-panel {\n  width: min(820px, 100%);\n  max-height: calc(100vh - 2rem);\n  margin: 0;\n  overflow: auto;\n}\n\n.dialog-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.page-footer {\n  margin-top: auto;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 1rem 1.25rem 1.5rem;\n  color: var(--muted);\n  font-size: 0.95rem;\n  text-align: center;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.14));\n}\n\n.page-footer a {\n  color: var(--accent-strong);\n}\n\n.page-footer a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 900px) {\n  .grid.two,\n  .solution-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .topbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .topbar-logo {\n    width: min(240px, 70vw);\n  }\n}\n\n@media (max-width: 640px) {\n  .page-content {\n    width: min(100% - 1rem, 1100px);\n  }\n\n  .card-tile,\n  .status-card {\n    grid-template-columns: 1fr;\n  }\n\n  .card-thumb {\n    width: 100%;\n    max-width: 220px;\n    height: auto;\n    aspect-ratio: 1 / 1;\n    justify-self: center;\n  }\n\n  .fab {\n    width: 72px;\n    height: 72px;\n    right: 1rem;\n    bottom: 1rem;\n  }\n\n  .button-row,\n  .topbar-actions,\n  .tabs {\n    width: 100%;\n  }\n\n  .button,\n  .ghost-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
